'use strict'

const fetchAuthorized = fetch

exports.submitForm = (requstBody, path, callback) => {
  return fetchAuthorized(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requstBody)
  }).then(response => {
    if (!response.ok) {
      return response.json().then(data => {
        return data
      })
    }
    if (callback) {
      callback()
    }
    return 0
  }).catch((error) => {
    throw new Error('Uncaught error: ' + error)
  })
}
